import React, { useRef, useState } from "react";
import "./Testimonials.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import { Swiper, SwiperSlide } from "swiper/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { Autoplay } from "swiper/modules";

const Testimonials = () => {
  const swiperRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleMainSliderClick = (direction) => {
    console.log("swiperInstance", swiperInstance, direction);

    if (swiperInstance) {
      if (direction === "prev") {
        swiperInstance.slidePrev();
      } else if (direction === "next") {
        swiperInstance.slideNext();
      }
    }
  };

  const data = [
    {
      review:
        "“Mr Kiran perfectly understood our vision of blending modern and traditional styles. From the wooden rafters to the moonlight ceiling effect, every detail was beautifully executed. Our home feels elegant yet cozy — just the way we imagined.”",
      name: "Dr. Ashlesha Shimpi",
    },
    {
      review:
        "“We wanted a luxurious and modern home with automation and premium finishes, and they delivered beyond expectations. The design, materials, and attention to Vastu were all thoughtfully handled. Truly a five-star experience!”",
      name: "Dr. Mohanish Dighe",
    },
    {
      review:
        "“Our home now feels bright, fresh, and so much more spacious. The tile combinations, storage solutions, and simple design touches made a big difference. Everything was done exactly as we wanted — modern yet practical.”",
      name: "Neha Gujar",
    },
    {
      review:
        "“We loved how our music theme was subtly incorporated into the interiors. The colors, matte finishes, and space planning perfectly matched our taste. The team really listened and made our ideas come alive beautifully.”",
      name: "Monika Saraf",
    },
    {
      review:
        "“Our flat had limited space, but the smart design made it look so much bigger. The open kitchen, Murphy bed, and bright colors completely transformed the home. Great creativity and practical approach throughout the project!”",
      name: "Apurv Cholke",
    },
  ];

  return (
    <section className="Testimonials">
      <div className="container">
        <Common_Title
          pageTitle="TESTIMONIALS"
          boxText="Warm Words  "
          subText=" Our Clients Say About Us "
        />

        <div className="content_div">
          <div className="swiper_div">
            <div className="swiper_container">
              <Swiper
                spaceBetween={15}
                slidesPerView={2}
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                onSwiper={setSwiperInstance}
                autoplay={{ delay: 3000 }}
                 modules={[Autoplay]}
                 loop
                className="mySwiper"
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  420: {
                    slidesPerView: 1.5,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  992: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 2,
                  },
                  1400: {
                    slidesPerView: 2,
                  },
                }}
              >
                {data?.map((item) => {
                  return (
                    <SwiperSlide>
                      <div className="review_card">
                        <p className="review_text">{item?.review}</p>
                        <p className="name_text">{item?.name}</p>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>

            <div className="silder_btn">
              <div className="back_btn_holder" onClick={() => handleMainSliderClick("prev")}>
                <div
                  className="back_btn"
                  
                >
                  <FontAwesomeIcon
                    icon={faPlay}
                    flip="horizontal"
                    className="icon"
                  />
                </div>
              </div>
              <div className="back_btn_holder" onClick={() => handleMainSliderClick("next")}>
                <div
                  className="back_btn"
                  
                >
                  <FontAwesomeIcon icon={faPlay} className="icon" />
                </div>
              </div>
            </div>
          </div>

          <div className="right_img_div">
            <img
              src="/assets/images/home/our_services/client_horizontal_images/img1.jpeg"
              className="right_img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
